import { FormInstance } from 'antd'

type FieldError = {
  name: (string | number)[]
  errors: string[]
}

export type ValidationError = {
  errorFields: FieldError[]
  outOfDate: boolean
}

export const useScrollToFirstError = (form: FormInstance) => {
  const onScrollToError = (error: ValidationError) => {
    const firstValidError = error?.errorFields?.find(
      (field) => field?.name?.[0] !== 'docs'
    )

    if (firstValidError) {
      form.scrollToField(firstValidError?.name, {
        behavior: 'smooth',
        block: 'center'
      })
    }
  }

  return { onScrollToError }
}
